import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteSignature, getSignature, saveSignature } from '../../../api/Signature/signature';
import { SavedSignature, SignatureInput } from '../../../utility/signature';

export const SIGNATURE_KEY = [ 'signature' ];

export function useSignature() {
  const query = useQuery({ queryKey: SIGNATURE_KEY, queryFn: () => getSignature(), retry: false });
  return { signature: (query.data?.data.signature as SavedSignature | null) ?? null, isLoading: query.isLoading };
}

export function useSignatureActions() {
  const queryClient = useQueryClient();
  // Saving or removing a signature changes who can sign, so refresh everything that depends on it.
  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: SIGNATURE_KEY });
    queryClient.invalidateQueries({ queryKey: [ 'contractOfferSetup' ] });
    queryClient.invalidateQueries({ queryKey: [ 'teamConnections' ] });
  };
  return {
    save: useMutation({ mutationFn: (input: SignatureInput) => saveSignature(input), onSuccess }),
    remove: useMutation({ mutationFn: () => deleteSignature(), onSuccess }),
  };
}
